import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const getEventCategoryList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.EVENT_CATEGORY_LIST);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getEventActiveCategoryList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.EVENT_ACTIVE_CATEGORY_LIST
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventCategoryById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_CATEGORY_BY_ID}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const addEventCategory = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.EVENT_CATEGORY_ADD,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updateEventCategory = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.EVENT_CATEGORY_UPDATE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const eventsAddUpdate = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.EVENT_ADD_UPDATE, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getEventStatusList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.EVENT_STATUS_ENUM_LIST);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getEventsByUserId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENTS_BY_USER_ID}?UserId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getEventsByTraderId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENTS_BY_TRADER_ID}?UserId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_BY_ID}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventLogoById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_LOGO_BASE_IMAGE_BY_ID}?eventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventByURL = async (eventURL) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_BY_URL}?URL=${eventURL}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getUpcomingEventList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_UPCOMING_EVENTS);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getAllEvents = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_ADMIN_ALL_EVENTS);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getAllEventsPendingApproval = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.GET_ADMIN_EVENTS_APPROVAL
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventByCategoryId = async (
  id,
  status = "",
  currentPage = 1
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${
        apiendpoints.GET_EVENT_BY_CATEGORY_ID
      }?CategoryId=${id}&pageNumber=${currentPage}&pageSize=${6}${
        status.length > 0 ? `&eventStatus=${status}` : ""
      }`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const eventsUploadImages = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.EVENT_UPLOAD_IMAGES,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const CreatePitch = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.EVENT_PITCH_ADD, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const ReducePitchPrice = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.EVENT_PITCH_REDUCE_PRICE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const UpdatePitch = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.EVENT_PITCH_UPDATE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getPitchesByEventId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_PITCHES}?EventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getPitchById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_PITCH_BY_ID}?Id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// export const setSelectedEvent = (event) => {
//   localStorage.setItem("selectedEvent", JSON.stringify(event));
// };

// export const getSelectedEvent = () => {
//   const selectedEvent = localStorage.getItem("selectedEvent");
//   if (selectedEvent !== null && selectedEvent !== undefined) {
//     return JSON.parse(selectedEvent);
//   } else {
//     return null;
//   }
// };
// export const removeSelectedEvent = () => {
//   localStorage.removeItem("selectedEvent");
// };

export const setPitchId = (id) => {
  localStorage.setItem("pitchId", id);
};

export const getPitchId = () => {
  const id = localStorage.getItem("pitchId");
  if (id !== null && id !== undefined) {
    return id;
  } else {
    return null;
  }
};
export const removePitchId = () => {
  localStorage.removeItem("pitchId");
};

export const getEventMapById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_MAP_API}?EventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventDocumentById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_DOCUMENT_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getSubmittedApplicationCountByEventtId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_SUBMITTED_APPLICATION_COUNT_BY_EVENTID}?eventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const eventsCategoryOrder = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.EVENT_CAT_ORDER_UPDATE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const UpdateEventStatus = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.EVENT_UPDATE_STATUS,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const GetApprovedTradersByEventId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_TRADERS_API}?eventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventOrganiserBussnessProfileByEventId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EO_BUSINESS_PROFILE_BY_EVENT_ID}?EventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//UNIT LIST
export const getUnitList = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_UNIT_LIST}?EventId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// UNIT EDIT
export const getUnitById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.EVENT_UNIT_BY_ID}?Id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//UNIT ADD AND UPDATE
export const CreateUnit = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.EVENT_UNIT_ADD_UPDATE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const ReduceUnitPrice = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.EVENT_UNIT_REDUCE_PRICE,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventApplicationStatus = async (eventURL, traderId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_APPLICATION_SATUS}?url=${eventURL}&traderId=${traderId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventApplicationStatusByType = async (
  appId,
  traderId,
  type
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_APPLICATION_SATUS_BY_TYPE}?appId=${appId}&traderId=${traderId}&type=${type}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getEventApplicationStatusByPitchId = async (
  type,
  appId,
  unitId,
  picthId
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_APPLICTION_STATUS_BY_PITCHID}?type=${type}&appId=${appId}&unitId=${unitId}&pitchId=${picthId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
